import { render } from "./SiteHeading.vue?vue&type=template&id=44a8b4ba"
import script from "./SiteHeading.vue?vue&type=script&lang=js"
export * from "./SiteHeading.vue?vue&type=script&lang=js"

import "./SiteHeading.vue?vue&type=style&index=0&id=44a8b4ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__